import { render, staticRenderFns } from "./ComponentBreadCrumbs.vue?vue&type=template&id=fe4e8244&scoped=true&"
import script from "./ComponentBreadCrumbs.vue?vue&type=script&lang=js&"
export * from "./ComponentBreadCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ComponentBreadCrumbs.vue?vue&type=style&index=0&id=fe4e8244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4e8244",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
